'use client'

import STAFF from '@/app/config/staff'
import MemberOverlay from '../member-overlay'
import RenderInView from '@/app/(site)/components/render-in-view'

const StaffGrid = () => {
    return (
        <div className="pb-10">
            <div className="grid grid-cols-2 gap-1.5 md:grid-cols-3 lg:grid-cols-4">
                {STAFF.map((member) => (
                    <div key={member.name} className="group relative">
                        <div key={member.name} className="aspect-square w-full bg-[#1C1C1C]">
                            <img alt={member.name} src={member.gif} className="h-full w-full object-cover" />
                        </div>

                        <MemberOverlay member={member} />
                    </div>
                ))}
            </div>

            <RenderInView>
                <div className="mx-auto flex animate-fade-in flex-col items-center py-1.5 text-white">
                    <div>
                        Questions? Feedback? Visit our <a href="https://support.giphy.com">Help Center</a>
                    </div>
                    <div>
                        GIFs by <a href="/csak">Csaba Klement</a>
                    </div>
                </div>
            </RenderInView>
        </div>
    )
}

export default StaffGrid
